import { Box, Card, Icon } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import {
  EngagementSettingsRootPageDocument,
  PulseAiReportDocument,
} from 'generated/resources/graphql'

import { DateNavigator } from 'modules/core/components/DateNavigator'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import EmployeePulseDatatable from 'modules/engagement/components/EmployeePulseDatatable'
import { useWeekNavigation } from 'modules/engagement/hooks/useWeekNavigation'
import Activate from 'modules/engagement/pages/pulse/Activate'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import WithToolTip from 'modules/performance_analytics/components/WithTooltip'

import Chart from './Chart'

const AiReportPage = () => {
  const { startDate, endDate, handleDateRangeChange } = useWeekNavigation()
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(EngagementSettingsRootPageDocument, {
    variables: { companyIds: company.id, moduleAvailabilityIds: [AvailableModules.engagement] },
  })
  const { data: teamsData, loading: teamsLoading } = useQuery(PulseAiReportDocument)

  const settings = data?.engagement?.settings?.at(0)
  const advancedConfigurationEnabled =
    data?.features.featuresConnection.edges.at(0)?.node.enabled ?? false
  const settingsManage = teamsData?.engagement?._policies?.settingsManage?.can ?? false
  const employeePulseEnabled = settings?.employeePulseEnabled ?? false

  const settingsManageEnabled =
    settingsManage && !employeePulseEnabled && settings && advancedConfigurationEnabled

  return (
    <ResponsivePage.Body error={null} loading={teamsLoading || loading}>
      <Box gap={'s48'}>
        {settingsManageEnabled && <Activate />}
        <EmployeePulseDatatable
          showTags
          dateRange={{ from: startDate, to: endDate }}
          teams={teamsData?.teams.teamsConnection.edges.map((edge) => edge.node) || []}
          tags={teamsData?.signals.tagsConnection.edges.map((edge) => edge.node) || []}
          actions={
            <DateNavigator
              startDate={startDate}
              endDate={endDate}
              onDateRangeChange={handleDateRangeChange}
              regularPeriods={['week']}
            />
          }
        >
          <Box width="full" height="s400">
            <Card>
              <Card.Content>
                <Box flexDirection="row" gap="s8">
                  <Card.Title size="small">
                    {i18n.t('engagement.pulse.pulse_ai_report.chart.title')}
                  </Card.Title>
                  <Card.Description>
                    {i18n.t('engagement.pulse.pulse_ai_report.chart.description')}
                  </Card.Description>
                  <WithToolTip label={i18n.t('engagement.pulse.pulse_ai_report.chart.tooltip')}>
                    <Icon.Medium icon="alert-circle-line" />
                  </WithToolTip>
                </Box>
                <Chart startDate={startDate} endDate={endDate} />
              </Card.Content>
            </Card>
          </Box>
        </EmployeePulseDatatable>
      </Box>
    </ResponsivePage.Body>
  )
}

export default AiReportPage
